import { render, staticRenderFns } from "./choosePJ.vue?vue&type=template&id=5e45009d&scoped=true&"
import script from "./choosePJ.vue?vue&type=script&lang=js&"
export * from "./choosePJ.vue?vue&type=script&lang=js&"
import style0 from "./choosePJ.vue?vue&type=style&index=0&id=5e45009d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e45009d",
  null
  
)

component.options.__file = "choosePJ.vue"
export default component.exports